import { Panel, PanelBorderRadius, PanelTheme } from '@apply/components';
import { IDashboardDrawBudget } from '@apply/api/src/api/DrawApi';
import { DrawApi } from '@apply/api';
import { DrawAddressLink } from './DrawAddressLink';

interface BlockedDrawCardProps {
    dashboardDrawBudget: IDashboardDrawBudget;
    set_modalDashboarDrawBudget: React.Dispatch<React.SetStateAction<DrawApi.IDashboardDrawBudget | undefined>>;
}

export const BlockedDrawCard: React.FC<BlockedDrawCardProps> = ({ dashboardDrawBudget, set_modalDashboarDrawBudget }) => {
    const pillText = (): string => {
        const { isApproved, isEquityMet, isBudgetMaxed } = dashboardDrawBudget;
        if (!isApproved) return 'Waiting for Approval';

        if (!isEquityMet) return 'Equity Not Met';

        if (isBudgetMaxed) return 'All Money has been Drawn';

        return 'Unknown Error';
    };

    return (
        <div className='row draw-blocked-container'>
            <DrawAddressLink
                dashboardDrawBudget={dashboardDrawBudget}
                set_modalDashboarDrawBudget={set_modalDashboarDrawBudget}
            />
            <div className='draw-blocked-container-status'>
                <div className='panelBadge'>
                    <Panel
                        theme={PanelTheme.Red}
                        padding={10}
                        borderRadius={PanelBorderRadius.Medium}
                    >
                        {pillText()}
                    </Panel>
                </div>
            </div>
        </div>
    );
};
